import { object, string } from "yup";

export const lineAccSchema = () => {
    const schema = {
        bot_basic_id: string()
            .test("startWith@", (value, testContext) => {
                if (!value?.startsWith("@")) {
                    return testContext.createError({
                        message: "Must start with @",
                    });
                }
                return true;
            })
            .required(),
        channel_secret: string().required(),
        channel_access_token: string().required(),
    };
    return object().shape(schema);
};
